import React, { useEffect, useRef } from 'react';
import { createPatch } from 'diff';
import { Box, SxProps } from '@mui/material';
import { Diff2HtmlUI } from 'diff2html/lib/ui/js/diff2html-ui';
import 'diff2html/bundles/css/diff2html.min.css';
import './DiffViewer.css';
// import { Scrollable } from './Scrollable';

interface DiffFile {
  content: string;
  name: string;
}

interface DiffViewerProps {
  original: DiffFile;
  modified: DiffFile;
  changeLog: string;
  sx?: SxProps;
  outputFormat?: 'line-by-line' | 'side-by-side';
  drawFileList?: boolean;
}

const DiffViewer: React.FC<DiffViewerProps> = (props: DiffViewerProps) => {
  const {
    original,
    modified,
    sx,
    outputFormat = 'line-by-line',
    changeLog,
    drawFileList = false,
  } = props;
  const diffRef = useRef<HTMLDivElement>(null);
  const diffString = createPatch(
    'Resume',
    original.content || '',
    modified.content || '',
    original.name,
    modified.name,
    {
      context: 5,
    }
  );

  useEffect(() => {
    if (diffRef.current && diffString) {
      // Clear previous content
      diffRef.current.innerHTML = '';
      diffRef.current.className = `diff-viewer`;
      // Generate HTML from diff string
      const diff2htmlUi = new Diff2HtmlUI(diffRef.current, diffString, {
        drawFileList: false,
        matching: 'lines',
        outputFormat,
        synchronisedScroll: true,
        highlight: true,
        fileContentToggle: false,
      });

      diff2htmlUi.draw();
      diff2htmlUi.highlightCode();
      diff2htmlUi.synchronisedScroll();
      //      diffRef.current.innerHTML = diff2htmlUi;
    }
  }, [diffString, outputFormat, drawFileList]);

  return (
    <Box
      sx={{
        position: 'relative',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flex: 1 /* Take remaining space in some-container */,
        overflow: 'auto' /* Scroll if content overflows */,
        p: 0,
        gap: 1,
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', p: 1 }}>{changeLog}</Box>
      <Box
        ref={diffRef}
        className="diff-viewer"
        sx={{
          display: 'flex',
          position: 'relative',
          minWidth: 'fit-content',
          minHeight: 'fit-content',
          fontFamily: 'monospace',
          fontSize: '14px',
        }}
      />
    </Box>
  );
};

export { DiffViewer };
